$(document).ready(function(){
  if(localStorage.getItem("wishlist") == "[]"){
    $('.wihslist_empty').show();
  }
  
  if(localStorage.getItem("customerId") != null && localStorage.getItem("wishlistOfUser") != null){
    localStorage.setItem("wishlist", JSON.stringify(JSON.parse(localStorage.getItem("wishlistOfUser"))[1]));
  }
  
  $(document).on('click','.wishlist-btn.product-detail-wishlist',function(){
    
    if(localStorage.getItem("customerId") != null){
      if($(this).hasClass("wishlist-added")){
        var storedColorsa=undefined;
        if(localStorage.getItem("wishlist") === null){
         storedColorsa= [];
        }
        else{
           storedColorsa=JSON.parse(localStorage.getItem("wishlist"));
        }
        storedColorsa.push($(this).attr("data-variant-id"));
        localStorage.setItem("wishlist", JSON.stringify(storedColorsa));
        let wishlistOfUser = [localStorage.getItem("customerId"),storedColorsa]
        localStorage.setItem("wishlistOfUser", JSON.stringify(wishlistOfUser))
        var removeValue = $(this).attr("data-variant-id");
        storedColorsa = $.grep(storedColorsa, function(n) {
          return n != removeValue;
        });  
        localStorage.setItem("wishlist", JSON.stringify(storedColorsa));
        localStorage.setItem("wishlistOfUser", JSON.stringify([localStorage.getItem("customerId"),storedColorsa]))
       // $(this).text("wishlist");
        $(this).removeClass("wishlist-added");
        if(localStorage.getItem("wishlist") == "[]"){
    $('.wihslist_empty').show();
  }
     }
     else{
       debugger;
      var storedColorsa=undefined;
        if(localStorage.getItem("wishlist") === null){
         storedColorsa= [];
        }
        else{
           storedColorsa=JSON.parse(localStorage.getItem("wishlist"));
        }
        storedColorsa.push($(this).attr("data-variant-id"));
        localStorage.setItem("wishlist", JSON.stringify(storedColorsa));
        let wishlistOfUser = [localStorage.getItem("customerId"),storedColorsa]
        localStorage.setItem("wishlistOfUser", JSON.stringify(wishlistOfUser))
        // var getdeta =JSON.parse(localStorage.getItem("wishlist"));
       // $(this).text("added");
        $(this).addClass("wishlist-added");
      }
      if($(this).parents('.quick-add-modal__content-info').length > 0){
        setwishlist();
      }
      checkwishlist();
    } else {
       localStorage.removeItem("wishlist");
      localStorage.removeItem("customerId");
    }
    
  });
  function checkwishlist(){
    $(".wishlist-result").hide();
    
    var getdetashow =JSON.parse(localStorage.getItem("wishlistOfUser"))[1];
     console.log(JSON.parse(localStorage.getItem("wishlistOfUser"))[0]);
    $.each(getdetashow, function (index, value) {  
      if(localStorage.getItem("customerId") != null && JSON.parse(localStorage.getItem("wishlistOfUser"))[0] == localStorage.getItem("customerId")){
        console.log(value);
        $(".wishlist-result."+value).show();
        $(".wishlist-result."+value).addClass('len');
      }else{
        localStorage.removeItem("wishlist");
        localStorage.removeItem("customerId");
      }
    });
  }
  
  checkwishlist();
  function setwishlist(){
  var getdeta =JSON.parse(localStorage.getItem("wishlist"));
  $('.wishlist-btn.product-detail-wishlist').removeClass("wishlist-added");
  $.each(getdeta, function (index, values)  { 
        $(".wishlist-btn.product-detail-wishlist").each(function(){
          $('.wishlist-btn.product-detail-wishlist[data-variant-id='+values+']').addClass("wishlist-added");
        })
    });
  }
  setwishlist();
  $(document).on('click', '.facets__item, .active-facets__button-remove, facet-remove .icon-close-small', function(){
    setTimeout(function () { setwishlist(); }, 1500);
  });
  $(document).on('click','.quick-add button.quick-add__submit',function(){
   setTimeout(function(){
     var getdeta =JSON.parse(localStorage.getItem("wishlist"));
      $('.quick-add-modal__content-info .wishlist-btn.product-detail-wishlist').removeClass("wishlist-added");
      $.each(getdeta, function (index, values)  
      { 
        $(".wishlist-btn.product-detail-wishlist").each(function(){
          $('.wishlist-btn.product-detail-wishlist[data-variant-id='+values+']').addClass("wishlist-added");
        })
      });
   },1000);
 });
  
});

// const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
// const LOCAL_STORAGE_DELIMITER = ',';
// const BUTTON_ACTIVE_CLASS = 'active';
// const GRID_LOADED_CLASS = 'loaded';

// const selectors = {
//   button: '[button-wishlist]',
//   grid: '[grid-wishlist]',
//   productCard: '.product-card-wrapper',
// };

// document.addEventListener('DOMContentLoaded', () => {
//   initButtons();
//   initGrid();
// });

// document.addEventListener('shopify-wishlist:updated', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
//   initGrid();
// });

// document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
// });

// document.addEventListener('shopify-wishlist:init-buttons', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
// });

// const fetchProductCardHTML = (handle) => {
//   const productTileTemplateUrl = `/products/${handle}?view=card`;
//   return fetch(productTileTemplateUrl)
//   .then((res) => res.text())
//   .then((res) => {
//     const text = res;
//     const parser = new DOMParser();
//     const htmlDocument = parser.parseFromString(text, 'text/html');
//     const productCard = htmlDocument.documentElement.querySelector(selectors.productCard); 
    
//     return productCard.outerHTML;
//   })
//   .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
// };

// const setupGrid = async (grid) => {
//   const wishlist = getWishlist();
//   const requests = wishlist.map(fetchProductCardHTML);
//   const responses = await Promise.all(requests);
//   const wishlistProductCards = responses.join('');
//   grid.innerHTML = wishlistProductCards;
//   grid.classList.add(GRID_LOADED_CLASS);
//   initButtons();

//   const event = new CustomEvent('shopify-wishlist:init-product-grid', {
//     detail: { wishlist: wishlist }
//   });
//   document.dispatchEvent(event);
// };

// const setupButtons = (buttons) => {
//   buttons.forEach((button) => {
//     const productHandle = button.dataset.productHandle || false;
//     if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
//     if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
//     button.addEventListener('click', () => {
//       updateWishlist(productHandle);
//       button.classList.toggle(BUTTON_ACTIVE_CLASS);
//     });
//   });
// };

// const initGrid = () => {
//   const grid = document.querySelector(selectors.grid) || false;
//   if (grid) setupGrid(grid);
// };

// const initButtons = () => {
//   const buttons = document.querySelectorAll(selectors.button) || [];
//   if (buttons.length) setupButtons(buttons);
//   else return;
//   const event = new CustomEvent('shopify-wishlist:init-buttons', {
//     detail: { wishlist: getWishlist() }
//   });
//   document.dispatchEvent(event);
// };

// const getWishlist = () => {
//   const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
//   if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
//   return [];
// };

// const setWishlist = (array) => {
//   const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
//   if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
//   else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

//   const event = new CustomEvent('shopify-wishlist:updated', {
//     detail: { wishlist: array }
//   });
//   document.dispatchEvent(event);

//   return wishlist;
// };

// const updateWishlist = (handle) => {
//   const wishlist = getWishlist();
//   const indexInWishlist = wishlist.indexOf(handle);
//   if (indexInWishlist === -1) wishlist.push(handle);
//   else wishlist.splice(indexInWishlist, 1);
//   return setWishlist(wishlist);
// };

// const wishlistContains = (handle) => {
//   const wishlist = getWishlist();
//   return wishlist.includes(handle);
// };

// const resetWishlist = () => {
//   return setWishlist([]);
// };